import {
  QuestionGroup,
  QuestionGroupInput,
  QuestionGroupType,
  QuestionInput,
  QuestionType
} from '@generated/base-types';
import { BlueprintControlValues } from '../../question-form/blueprint-view/blueprint-view.component';

export class LoadQuestionGroup {
  public static readonly type = '[Question Group Edit] Load Question Group';

  constructor(
    public readonly questionGroupId: QuestionGroup['id'],
    public readonly poolId: string
  ) {}
}

export class CloneQuestionGroup {
  public static readonly type = '[Question Group Edit] Clone Question Group';

  constructor(
    public readonly questionGroupId: QuestionGroup['id'],
    public readonly poolId: string
  ) {}
}

export class CreateQuestionGroup {
  public static readonly type = '[Question Group Edit] Create Question Group';

  constructor(
    public readonly questionType: QuestionType,
    public readonly questionGroupType: QuestionGroupType
  ) {}
}

export class PatchBlueprintForm {
  public static readonly type = '[Question Group Edit] Patch Blueprint Form';
  constructor(
    public readonly blueprintForm: BlueprintControlValues,
    public readonly activeQuestionIdx: number
  ) {}
}

export class PatchMetadataForm {
  public static readonly type = '[Question Group Edit] Patch Metadata Form';
  constructor(public readonly metadataForm: QuestionGroupInput) {}
}

export class AddNewQuestion {
  public static readonly type = '[Question Group Edit] Add New Question ';

  constructor(public readonly questionType: QuestionType) {}
}

export class DeleteQuestion {
  public static readonly type = '[Question Group Edit] Delete Question';

  constructor(public readonly question: QuestionInput) {}
}

export class SetQuestions {
  public static readonly type = '[Question Group Edit] Set Questions';

  constructor(public readonly questions: QuestionInput[]) {}
}

export class UpdateQuestionGroupRequest {
  public static readonly type =
    '[Question Group Edit] Update Question Group Request';
}

export class CreateQuestionGroupRequest {
  public static readonly type =
    '[Question Group Edit] Create Question Group Request';
}

export class ChangeQuestionType {
  public static readonly type = '[Question Group Edit] Change Question Type';

  constructor(
    public readonly questionId: string,
    public readonly newType: string,
    public readonly removeResponseOption?: number
  ) {}
}
